import React from "react";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  // Función para determinar qué páginas mostrar (sin puntos suspensivos)
  const getPageNumbers = () => {
    const pages = [];
    
    // Si hay 5 páginas o menos, mostrar todas
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
      return pages;
    }

    // Siempre mostrar primera página
    pages.push(1);

    // Calcular el rango de páginas a mostrar (2 números)
    let startPage, endPage;

    // Si estamos cerca del inicio (páginas 1, 2, 3)
    if (currentPage <= 2) {
      startPage = 2;
      endPage = 3;
    }
    // Si estamos cerca del final (últimas 2 páginas)
    else if (currentPage >= totalPages - 1) {
      startPage = totalPages - 2;
      endPage = totalPages - 1;
    }
    // En el medio: mostrar página actual y la siguiente
    else {
      startPage = currentPage;
      endPage = currentPage + 1;
    }

    // Agregar páginas del rango
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    // Siempre mostrar última página
    pages.push(totalPages);

    return pages;
  };

  const pageNumbers = getPageNumbers();

  return (
    <div className="flex justify-center md:justify-end items-center mt-6 px-2 md:pr-4 gap-2 md:gap-3">
      {/* Botón anterior */}
      <button
        onClick={() => onPageChange(Math.max(currentPage - 1, 1))}
        disabled={currentPage === 1}
        className={`w-8 h-8 md:w-10 md:h-10 flex justify-center items-center rounded-full text-gray text-sm md:text-base transition-colors ${
          currentPage === 1
            ? "text-gray-400 cursor-not-allowed opacity-50"
            : "hover:bg-gray-200 hover:text-black"
        }`}
      >
        ◀
      </button>

      {/* Páginas */}
      {pageNumbers.map((page) => (
        <button
          key={page}
          onClick={() => onPageChange(page)}
          className={`w-8 h-8 md:w-10 md:h-10 flex justify-center items-center border-2 rounded-full text-sm md:text-base transition-all ${
            currentPage === page
              ? "bg-main-blue text-white shadow-lg border-main-blue scale-105"
              : "border-gray text-gray hover:bg-gray-200 hover:text-black hover:border-black hover:scale-105"
          }`}
        >
          {page}
        </button>
      ))}

      {/* Botón siguiente */}
      <button
        onClick={() => onPageChange(Math.min(currentPage + 1, totalPages))}
        disabled={currentPage === totalPages}
        className={`w-8 h-8 md:w-10 md:h-10 flex justify-center items-center rounded-full text-gray text-sm md:text-base transition-colors ${
          currentPage === totalPages
            ? "text-gray-400 cursor-not-allowed opacity-50"
            : "hover:bg-gray-200 hover:text-black"
        }`}
      >
        ▶
      </button>
    </div>
  );
};

export default Pagination;
